import { createContext, useContext } from 'react';

export interface AuthUser {
  id: string;
  email: string;
  displayName?: string;
  tenantSlug: string;
  roles: string[];
}

export interface AuthContextValue {
  isAuthenticated: boolean;
  user: AuthUser | null;
  isLoading: boolean;
  authError: string | null;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
  user: null,
  isLoading: true,
  authError: null,
  logout: async () => {},
});

export function useAuth(): AuthContextValue {
  return useContext(AuthContext);
}
